import Vue from 'vue';

import cdnUrl from '@core/mixins/cdnUrl';
import route from '@core/mixins/route';
import shortcutsStore from '@core/mixins/shortcutsStore';
import error from '@core/mixins/error';

const files = require.context('./', true, /\.js$/);

Vue.mixin(cdnUrl);
Vue.mixin(route);
Vue.mixin(shortcutsStore);
Vue.mixin(error);

files.keys().forEach((key) => {
    if (key === './index.js') return;
    Vue.mixin(files(key).default);
});
